import React from "react";
import SplitPipe from "../components/SplitPipe";
export default ({ isActive }) => {
  return (
    <div className="component split-pipe-component hide-overflow">
      <SplitPipe isActive={isActive} />
    </div>
  );
};